import { NgModule } from '@angular/core';
import { MenuWheelComponent } from './menuwheel.component';

@NgModule({
    declarations: [MenuWheelComponent],
    imports: [],
    exports: [MenuWheelComponent]
})

export class MenuWheelModule {}